<template>
  <div class="accidents">
    <div class="table">
      <div class="table__header box box--default">
        <div class="table__label table__label--medium table__label--fixed">
          Status
        </div>
        <div class="table__label table__label--medium">    {{ $t(`accidentsTables.${"policyNr"}`) }}</div>
        <div class="table__label table__label--large">{{ $t(`accidentsTables.${"company"}`) }}</div>
        <div class="table__label table__label--medium">{{ $t(`accidentsTables.${"industry"}`) }}</div>
        <div class="table__label table__label--medium">{{ $t(`accidentsTables.${"damageFrom"}`) }}</div>
        <div class="table__label table__label--medium">{{ $t(`accidentsTables.${"damageTo"}`) }}</div>
        <div class="table__label table__label--medium">{{ $t(`accidentsTables.${"amount"}`) }}</div>
        <div class="table__label table__label--medium">{{ $t(`accidentsTables.${"reportDamage"}`) }}</div>
        <div class="table__label table__label--medium table__label--more-horizontal table__label--last"></div>
      </div>

      <div class="table__body">
        <Loading v-if="detailsLoading" />
        <template v-else>
          <div v-if="!canShowAccidents" class="table__no-data">
            <NoData :type="'no-permission'" />
          </div>
          <template v-else>
            <AccidentsPolicy v-for="policy in policies" :key="policy.id" :policy="policy" />
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed } from "vue";
import AccidentsPolicy from "@/components/AccountDetails/AccidentsPolicy";
import Loading from "@/partials/Loading";
import NoData from "@/partials/NoData";
export default {
  name: "Accidents",

  components: {
    AccidentsPolicy,
    Loading,
    NoData,
  },

  props: {
    policies: {
      required: true,
      type: Array,
    },

    detailsLoading: {
      required: true,
      type: Boolean,
    },
  },

  setup() {
    const store = useStore();
    const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
    const customerTeamId = computed(() => store.getters.customer?.team_id ?? store.getters.customer?.team?.id ?? null);
    const canShowAccidents = computed(() => {
      if (isSuperAdmin.value) return true;
      return store.getters.hasTeamPermission("policy_accident_show", customerTeamId.value);
    });
    return { canShowAccidents };
  },
};
</script>
<style scoped>
.loading {
  height: 76vh;
}
</style>